import { createContext } from 'react'

import { EMAIL_FORM_CONTEXT_DEFAULT_VALUE } from './Email.constants'

export const EmailFormContext = createContext(EMAIL_FORM_CONTEXT_DEFAULT_VALUE)
